import React, { useContext, useState } from "react";
import { Modal, Input, Checkbox, message, Button } from "antd";
import { AuthContext } from "../../config/AuthContext";
import { PostSugeriment } from "../../dao/jutge/PostSugeriment";

interface Props {
    visible: boolean;
    onClose: () => void;
}

const SugerimentsModal: React.FC<Props> = ({ visible, onClose }) => {
    const { userId } = useContext(AuthContext);
    const [text, setText] = useState("");
    const [anonim, setAnonim] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!text.trim()) {
            message.warning("Escribe algo por favor.");
            return;
        }
        setLoading(true);
        const success = await PostSugeriment(userId + "", text, anonim);
        setLoading(false);

        if (success) {
            message.success("Sugerencia enviada correctamente!");
            setText("");
            setAnonim(false);
            onClose();
        } else {
            message.error("Error al enviar sugerencia.");
        }
    };

    return (
        <Modal
            title="Enviar Sugerencia / Incidencia"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>
                    Enviar
                </Button>,
            ]}
        >
            <Input.TextArea
                rows={4}
                placeholder="Describe tu sugerencia o incidencia..."
                value={text}
                onChange={(e) => setText(e.target.value)}
                style={{ marginBottom: 16 }}
            />
            <Checkbox checked={anonim} onChange={(e) => setAnonim(e.target.checked)}>
                Enviar como anónimo
            </Checkbox>
        </Modal>
    );
};

export default SugerimentsModal;
